export { default } from "./PasswordRequiredToRegisterConfirmation";
